export default "__VITE_ASSET__DnDM7OOf__"